import { useContext } from 'react';
import { PermissionsContext } from '@/lib/permissionsContext';

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions must be used within PermissionsProvider');
  }
  return context;
};
